import React from 'react';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';

export default function Shipping() {
  const sections = [
    {
      title: 'Delivery Coverage',
      content: 'NoBrand Store ships pan-India. International shipping is not available at this time.'
    },
    {
      title: 'Dispatch Time',
      content: 'Orders are dispatched within 2–3 business days after payment confirmation.'
    },
    {
      title: 'Delivery Time',
      content: 'Estimated delivery is 3–5 business days after dispatch, depending on your location. Remote areas may take longer.'
    },
    {
      title: 'Tracking',
      content: 'A tracking number will be shared on WhatsApp once your order is dispatched.'
    },
    {
      title: 'Shipping Charges',
      content: 'Free shipping on orders above ₹999. Shipping charges apply for orders below ₹999 and will be shown at checkout.'
    },
    {
      title: 'Delivery Address',
      content: 'Please ensure someone is available at the delivery address to receive the package. NoBrand Store is not responsible for failed deliveries due to unavailability.'
    },
  ];

  return (
    <div className="app-shell">
      <Navbar showBack title="Shipping Policy" />
      <div className="page-body" style={{ paddingBottom: 80 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 6, color: 'var(--navy)' }}>Shipping Policy</h1>
        <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 24 }}>Last updated: June 2026</p>

        {sections.map((s, i) => (
          <div key={i} style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', marginBottom: 6 }}>{s.title}</div>
            <p style={{ fontSize: 13, lineHeight: 1.8, color: '#555' }}>{s.content}</p>
          </div>
        ))}
      </div>
      <BottomNav />
    </div>
  );
}